import React from "react";
import Eyebrow from "./Eyebrow";
import Title from "./Title";
import Subtitle from "./Subtitle";

const Content = () => (
  <div className="hero__content">
    <Eyebrow />
    <Title />
    <Subtitle />
  </div>
);

export default Content;
